import React from "react";
import { Link, Routes, Route, useParams, useNavigate } from "react-router-dom";
import {
  ArrowDownTrayIcon,
  ArrowLeftIcon
} from "@heroicons/react/24/outline";

/* ------------------------------------------------------------
   Adatszerkezet – slug → { title, type, parts }
     type = "text"       → parts: { body }
     type = "pdf"        → parts: { file }
     type = "gallery"    → parts: { body, images: [src] }
------------------------------------------------------------ */

const grants = [
  {
    slug: "vca-2021-002254",
    title:
      "A Városi Civil Alap keretében 2021. évben meghirdetett ‘civil közösségi tevékenységek és feltételeinek támogatása’ – VCA-KP-1-2021/3-002254",
    type: "text",
    parts: {
      body:
        "Az elnyert pályázati összegből 3 millió Ft értékben varrattunk 10 rend férfi kalotaszegi viseletet, azaz 10 db bőujjú hímzett mérai inget, 10 db bricses nadrágot, 10 db mellényt és 5 db díszes bujkát. Valamint női kalotaszegi viseletekből elkészülhetett egyesületünk részére 10 db szoknya, 8 db pántlikás kötény és 5 db díszes mellény.",
    },
  },
  {
    slug: "top-2021-02410",
    title:
      "Balaton Tánc Egyesület civil ház felszereléséhez kapcsolódó eszközbeszerzése – TOP‑7.1.1‑16‑H‑ERFA‑2021-02410",
    type: "pdf",
    parts: { files: [{ file: "top-2021-02410.pdf", label: "Beszámoló" }] },
  },
  {
    slug: "top-2021-00923",
    title:
      "Balaton Tánc Egyesület civil ház felszereléséhez kapcsolódó eszközbeszerzése – TOP‑7.1.1‑16‑H‑ERFA‑2021‑00923",
    type: "pdf",
    parts: { files: [{ file: "top_2021_00923.pdf", label: "Beszámoló" }] },
  },
  {
    slug: "csoori-2024",
    title: "Csoóri Sándor Program 2024",
    type: "gallery",
    parts: {
      heroImages: [
        "/gallery/cs20_hero1.jpg",
        "/gallery/cs20_hero2.jpg"
      ],
      body: `Táncházak szakmai támogatása, programjainak megvalósítása, a közösségek megerősítése

      Az idei támogatási időszakra kért összegből, a már meglévő programjainkat fejlesztettük és működtettük tovább, hogy kialakíthassunk egy felmenő rendszerű, hagyományaink iránt továbbra is érdeklődő közeget.

      Az Apropók Táncház, mely 2017 áprilisa óta töretlen népszerűségnek örvend a siófoki kisgyermekes családok körében. Sikerét mutatja, hogy nem csak a városbéli gyermekek látogatják programunkat, hanem a környező települések apró, ropni vágyói is. A pályázati kiírásban megjelölt időszakban 7 db Apropók Táncházat tartottunk. Fontosnak véljük, hogy a legkisebb korosztály is megismerkedhessen az élő népzene varázsával. A táncház vezetésével megbízott oktatók, Vastag Richárd és Fodor Janka volt, akik gondoskodtak arról, hogy élmény szerűvé varázsolják a kicsik számára a néptánc és népi játékok világát.

      A Balaton Táncműhely újabb kurzust indított kezdő táncosok részére. A tánctanítások részét képezi egy élőzenés táncház az adott anyagból, ami a pályázati időszakban a Bukovinai és a Szilágysági táncokat ölelte fel. Kurzusainkon azt szeretnénk, hogy magabiztos alapokat szerezzenek a résztvevők és a táncházak alkalmával bátran tudják alkalmazni.

      Tavaly, az első Balaton Családi Napunk után sorra érkeztek a kérdések, hogy mikor ismételjük meg ezt a varázslatos napot. Ismét olyan színes programokkal készültünk, mely a család minden tagjának szórakozást nyújthat. Ide építettük be a Tini Táncházat, melyet felső tagozatos, illetve gimnazista gyermekek részére álmodtunk meg. Azok számára, kik a felnőtt táncházakat még nem, illetve az Apropók Táncházakat koruk miatt már nem látogatják. Vastag Richárd vezetésével a tanítás után a megszerzett, meglévő tudásból szabad, kedvükre való táncolás következett élő népzenére. Az anyagtanulásokhoz és a muzsika szolgáltatásához különböző oktatókat és zenekarokat hívtunk, a meglévő kapcsolatrendszerünkből.

      Közösségünk építése céljából augusztus végén ellátogattunk Somogyország archaikus részére Zselickisfaludra, ahol magunkba szívtuk a térség energiáit, amit egy Somogyi táncház koronázott meg.

      Programjainkkal és táncházainkkal szeretnénk nagyobb teret biztosítani városunkban, a népzene és néptánc hagyományának. Kulturális szórakozási lehetőséget teremteni hagyományaink tovább éltetése mellett, minden generáció számára.

      A támogatásból származó összeget a fenti programok finanszírozására fordítottuk, ami tartalmazza az oktatói díjakat, zenekari költségeket.

      CSSP-TANCHAZ-2024-0177



      Hazai néptáncegyüttesek szakmai támogatása, programjainak megvalósítása, a közösségek megerősítése

      Projekt Címe: Tovább az úton

      2024 július végén nagy megtiszteltetés érte az együttesünket, mivel meghívást kaptunk a Bulgáriai Nemzetközi Néptánc Fesztiválra Plovdivba. A műsorok színvonalas előadásához sok próba és a Tarsoly zenekar közreműködése kellett. Fellépések megkoronázása a Bulgária legnagyobb Római kori amfiteátrumi fellépése volt, ahol lélegzetelállító körülmények és közel 5000 néző előtt mutathattuk be kultúránkat.

      A nyár végeztével megkezdődtek a munkák az év hátralevő részére. Először megkezdtük a felkészülést a november 9-ei Szekszárdi Néptáncfesztiválra. Két koreográfiával, "Majd el, hazamegyünk" és az "Eszenyői patakmalom" című alkotásokkal készültünk. A sok gyakorlás meghozta az eredményét, I. helyezés együttesi nívódíjban részesültünk, valamint mindkettő alkotást Koreográfiai Nívódíjal jutalmazták.

      Folytattuk a felkészülést az év végi nagy bemutatónkra, ami a „Lelkemből lelkednek” címet viselte. A műsort rendkívül nagy érdeklődés fogadta a siófoki Kálmán Imre Művelődési Központ zsúfolásig megtelt.

      A 2025-ös év nagy örömhírekkel kezdődött hiszen együttesünket immár 62 éves története során egyedülálló elismerés érte, mivel bejutottunk egymást követő két évben is a Budapesti Operettszínházban megrendezésre kerülő Néptáncantológiára.
      Együttesünk tagjai és vezetői mérhetetlenül büszkék, hogy nem csak együttesi de egyéni teljesítmények terén is haladunk előre. Művészeti vezetőnk Csuti Péter István megnyerte a 27. Országos Szólótáncfesztivál Aranysarkantyú díját.

      Eljött a március a Budapesti Operettszínházban megrendezésre kerülőt a Néptáncantológia. Idén a "Majd el, hazamegyünk" című ipolymenti koreográfiánkkal állhattunk a zsúfolt házas közönség elé.

      Húsvét alkalmával Siófok Főtere lett a Tánckavalkád és locsolkodás színtere. Nagy siker koronázta az évek óta megtartott húsvéti locsolkodás és táncház produkciónkat.

      Eljött a május vele pedig együttesünk életében az eddigi legnagyobb megmérettetés. A Martin György Néptáncszövetség rendezésében és Együttesünk lebonyolításában megrendezésre került a Néptáncosok Országos Bemutató Színpada minősítő fesztivál. A zsűri előtt bemutatásra került a "Lélek-képek" című darabunk, ami az ország egyik legrangosabb versenyfesztiválján „Kiválóan Minősült” elismerést érdemelt ki.

      Nyár közeledtével Fodor Janka művészeti vezetőnk először a Balatonszabadi Önkormányzatól Elismerő oklevelet majd nagyberényi Faust Díjjat vehetett át szakmai munkájának elismeréseként.

      A forró nyár elején még egy örömteli felkérésnek tehettünk eleget. Együtt állhattunk színpadra a Magyar Állami Népi Együttessel a „Táncos magyarok” című előadásukban.

      Nyári szünet végén jött egy ismételten izgalmakkal teli felkérés. Államalapításunk ünnepén Együttesünkkel két helyszínen, Budapesten, a Vörösmarty téren megrendezésre kerülő Csárdafesztiválon és Siófokon a Bor és Kenyér Ünnepén találkozhattak a nézők. A siófoki előadásunk különlegessége volt, hogy most először adhatunk közös műsort erdélyi testvérvárosunkkal, Gyergyószentmiklós táncosaival, a Hóvirág Néptáncegyüttessel.

      A támogatásból származó összeget a fenti programok finanszírozására fordítottuk, ami tartalmazza koreográfiai díjakat, oktatói díjakat, zenekari és utazási költségeket.

      CSSP-NEPTANC-MO-2024-0237

      Köszönjük szépen a Csoóri Sándor Alap támogatását!
      `,
      images: [
        "/gallery/csoori2024_01.jpg",
        "/gallery/csoori2024_02.jpg",
        "/gallery/csoori2024_03.jpg",
        "/gallery/csoori2024_04.jpg",
        "/gallery/csoori2024_05.jpg",
        "/gallery/csoori2024_06.jpg",
        "/gallery/csoori2024_07.jpg",
        "/gallery/csoori2024_08.jpg"
      ],
    },
  },
  {
    slug: "csoori-2022-2023",
    title: "Csoóri Sándor Program 2022-2023",
    type: "gallery",
    parts: {
      heroImages: [
        "/gallery/cs20_hero1.jpg",
        "/gallery/cs20_hero2.jpg"
      ],
      body: `A 2022-es táncház pályázaton nyert támogatást négy korosztály: aprók, gyermek, tini és felnőtt táncház tartására fordítottuk. A közös táncolás, éneklés segítségével próbáltuk a különböző generációkat közel hozni egymáshoz. A nagy létszámmal látogatott apropók táncház minden hónap első szombatján került megszervezésre, két alkalommal tiniknek, egy alkalommal gyermekeknek, négyszer felnőtteknek volt korosztályos táncház.

A táncházak megvalósításában Angyal Marianna, Fodor Janka Papp Károly volt segítségünkre. Zenét szolgáltatott a Sólya zenekar, Deáky Márton és barátai, valamint a Tarsoly zenekar.

A pályázati ciklus lehetőséget biztosított az együttes számára, hogy elvárásainak megfelelően elkezdje felkészülését a 60 éves jubileumi évre. A nyári szezonban edzőtáborban voltak a táncosok. A női tánckar tagjainak Strack Orsolya moldvai táncokat tanított, a férfi tánckarnak Sikentáncz Szilveszter györgyfalvi koreográfiát tanított be. Ez a két koreográfia az immáron hagyományosnak mondható táncszínházi előadásunk keretében került bemutatásra, mely ebben az évben a „Szilánkok” elnevezést kapta. Két alkalommal táncolhattunk telt ház előtt. A neves vendégoktatók tiszteletdíja mellett a pályázatban elnyert összegből a viselettárunkat is bővíteni tudtuk, parasztingeket, moldvai viseleteket, egy székely viseletet, valamint somogyi kötényeket vásároltunk, ez hozzájárult együttesünk színvonalas működésének továbbfejlődéséhez.

CSSP-TANCHAZ-2022-0211

CSSP-NEPTANC-MO-2022-0307`,
      images: [
        "/gallery/csoori22_01.jpg",
        "/gallery/csoori22_02.jpg",
        "/gallery/csoori22_03.jpg",
        "/gallery/csoori22_04.jpg",
        "/gallery/csoori22_05.jpg",
        "/gallery/csoori22_06.jpg",
        "/gallery/csoori22_07.jpg",
        "/gallery/csoori22_08.jpg",
        "/gallery/csoori22_09.jpg",
        "/gallery/csoori22_10.jpg",
      ],
    },
  },
  {
    slug: "csoori-2021",
    title: "Csoóri Sándor Program 2021",
    type: "gallery",
    parts: {
      heroImages: [
        "/gallery/cs20_hero1.jpg",
        "/gallery/cs20_hero2.jpg"
      ],
      body: `A 2021-es táncházas keretet tini, felnőtt és többgenerációs táncházak és tánctanítások szervezésére fordítottuk, elsősorban a néptáncot és népzenét kedvelő ifjúsági és felnőtt korosztály számára. Célunk volt, hogy a pandémiát követően még jobban kiszélesedő generációs szakadékokat átíveljük, a korosztályokat közelebb hozzuk egymáshoz a táncház nyújtotta közös táncolás, éneklés által.

Ezeket a táncházakat augusztusra szerveztük, minden hétvégére egyet, hogy a nyári tanítási szünet alatt se szenvedjen senki hiányt a néptánc és népzene nyújtotta élményekből. Két tini és két felnőtt táncház valósult meg ezeken a hétvégéken.

A tini táncházakon a siófoki Művészeti Iskola néptánctagozatának növendékei vettek részt a családtagok és barátok kíséretében, ahol nagyrészt somogyi és szilágysági táncanyagot gyakorolhattak a résztvevők.

A felnőtt táncházakat a Balaton Táncegyüttes aktív táncosai és hozzátartozóik látogatták elsősorban. Itt a palatkai, bukovinai és györgyfalvi táncok rejtelmeibe vetettük bele magunkat.

Vendégoktatónk Sikentáncz Szilveszter volt, a talpalávaló muzsikát pedig a Tarsoly zenekar tagjai (Jobbágy Bence, Böröcz Balázs, Blaskó Norbert, Hornich Thomas, Bencze Mátyás) szolgáltatták a táncházak alkalmával. Az év végét pedig egy összevont közös egész estés táncházzal zártuk szintén a Tarsoly zenekar közreműködésével. Itt az egész 2022-es év táncanyagait sorra vettük, amelyekkel komolyabban foglalkoztunk: somogyi, szilágysági, ipolymenti, moldvai, bukovinai, palatkai, györgyfalvi.

A pályázati ciklus két legfontosabb eredménye az “Önök színe előtt bátran megállottam” című táncszínházi előadásunk megvalósulása, illetve a Szekszárdi Néptáncfesztivál sikerei. Előbbi esetében a terveink szerint méltó képpen emlékezhettünk egyik alapítónk, Együd Árpád szellemisége előtt. Mind két előadásunkat telt ház előtt táncolhattuk el, mely táncosainknak életre szóló élményeket nyújtottak. Ezen túl a felkészülés alatt technikailag is rengeteget fejlődött együttesük tánckara és lehetőségünk nyílt az eddigi színvonalunkon emelni mind megjelenésben, mind pedig a színpadon nyújtott teljesítményben is egyaránt.

A Szekszárdi Néptáncfesztiválon III. helyezés Kiemelt nívódíjat, valamint Muharay Különdíjat nyert el együttesünk, mely az utóbbi évek legnagyobb szakmai sikerét jelentette műhelyünk számára. A pályázati lehetőségek nélkül ezen terveink nem valósulhattak volna meg.

CSSP-TANCHAZ-2021-0275

CSSP-NEPTANC-MO-2021-0377`,
      images: [
        "/gallery/csoori21_01.jpg",
        "/gallery/csoori21_02.jpg",
        "/gallery/csoori21_03.jpg",
        "/gallery/csoori21_04.jpg",
        "/gallery/csoori21_05.jpg",
        "/gallery/csoori21_06.jpg",
        "/gallery/csoori21_07.jpg",
        "/gallery/csoori21_08.jpg",
        "/gallery/csoori21_09.jpg",
        "/gallery/csoori21_10.jpg",
        "/gallery/csoori21_11.jpg",
        "/gallery/csoori21_12.jpg",
        "/gallery/csoori21_13.jpg",
        "/gallery/csoori21_14.jpeg",
        "/gallery/csoori21_15.jpeg",
        "/gallery/csoori21_16.jpg",
        "/gallery/csoori21_17.jpg",
        "/gallery/csoori21_18.jpg",
      ],
    },
  },
  {
    slug: "csoori-2020",
    title: "Csoóri Sándor Program 2020",
    type: "gallery",
    parts: {
      heroImages: [
        "/gallery/cs20_hero1.jpg",
        "/gallery/cs20_hero2.jpg"
      ],
      body: `A 2020-ban elnyert pályázatnak köszönhetően elkezdődtek a Balaton Táncegyüttes alapítója, Együd Árpád emlékműsorának munkálatai. Sikentáncz Szilveszterrel ipolymenti táncokat tanultunk, melyből koreográfia is készült. Horváth Tibor és Zóka Éva zselici táncokat tanított együttesünknek, melyből szintén létrejött egy színpadi koreográfia is. Ezen oktatói és koreográfusi díjak kifizetése nem jöhetett volna létre a pályázatban elnyert támogatás nélkül.
    
Repertoárunk bővítése mellett a támogatási összeg lehetőséget nyújtott művészeti vezetőink megtartására is, hiszen a dologi kiadásokból az említett személyek tiszteletdíját is finanszírozni tudtuk.

A fennmaradó összegből Veszprémbe utazott együttesünk, ahol a Táncháztalálkozó Országszerte című programon vettünk részt. Ezen túl két pár táncosunk és együttesünk művészeti vezetője a Nyár 21 című televíziós műsorba kapott meghívást, melynek útiköltségét szintén a fennmaradó pályázati összegből fedeztük.

Egész estés gyermek táncházat és mesejátékot szerveztünk az együttesünk közvetlen utánpótlását képző művészeti iskolás gyerekeknek, melyet Horti Zoltán vezetett le.

Többgenerációs táncházat és tánctanítást szerveztünk a néptáncot és népzenét kedvelő ifjúsági és felnőtt korosztály számára. Célunk volt, hogy a pandémiát követően még jobban kiszélesedő generációs szakadékokat átíveljük, a korosztályokat közelebb hozzuk egymáshoz a táncház nyújtotta közös táncolás, éneklés által. Ezeken a táncházakon ipolymenti, szilágysági és somogyi táncanyaggal ismerkedhetnek meg a résztvevők helyi és vendégoktatók közreműködésével. Ezen túl tartottunk tematikus táncházakat is, mint például a húsvéti és pünkösdi táncházak, melyeket csapatjátékokkal, vetélkedőkkel, „Nyúlkirály” választással igyekeztünk színesíteni.

A pályázatban elnyert összeg segítségével, a megvalósult programjaink és táncházaink nagyobb teret biztosítottak városunkban a népzene és néptánc hagyományának. Kulturális szórakozási lehetőséget, táncteret biztosítottunk minden korosztály számára és a pandémia okozta károk helyreállításában is kiemelten fontos segítséget nyújtott együttesünk számára.

CSSP-NEPTANC-MO-2020-0377

CSSP-TANCHAZ-2020-0282

A pályázat leírása és a kapcsolódó anyagok az alábbi hivatkozásra kattintva tekinthetők meg:`,
      cta: {
        text: "Csoóri Sándor Program 2020",
        href: "https://emet.gov.hu/csoori-sandor-program-2020/"
      },
      images: [
        "/gallery/csoori20_01.jpg",
        "/gallery/csoori20_02.jpg",
        "/gallery/csoori20_03.jpg",
        "/gallery/csoori20_04.jpg",
        "/gallery/csoori20_05.jpg",
        "/gallery/csoori20_06.jpg",
        "/gallery/csoori20_07.jpg",
        "/gallery/csoori20_08.jpg",
        "/gallery/csoori20_09.jpg",
        "/gallery/csoori20_10.jpg",
        "/gallery/csoori20_11.jpg",
        "/gallery/csoori20_12.jpg",
        "/gallery/csoori20_13.jpg",
        "/gallery/csoori20_14.jpg",
        "/gallery/csoori20_15.jpg",
        "/gallery/csoori20_16.jpg",
        "/gallery/csoori20_17.jpg",
        "/gallery/csoori20_18.jpg",
      ]
    }
  },
  {
    slug: "csoori-2019",
    title: "Csoóri Sándor Program 2019",
    type: "gallery",
    parts: {
      heroImages: [
        "/gallery/cs20_hero1.jpg",
        "/gallery/cs20_hero2.jpg"
      ],
      body: `A pályázat nagyban segítette együttesünk működését, hiszen az elnyert összegből fedezni tudtuk az élő népzenei költségeink nagy részét, melynek köszönhetően továbbra is élőzenei kíséret mellett léphettünk színpadra. Ezáltal sikerült megtartani a tőlünk megszokott színvonalat. Ezen túl a művészeti vezetőnk bérének egy részét is meg tudtuk finanszírozni a pályázatban elnyert összegből, mely további anyagi biztonságot adott a táncegyüttesünknek. Ruhatárunk is tovább gyarapodott a pályázatnak köszönhetően 10 db női és 10 db férfi székely viselettel, így a táncosaink gyönyörű, új viseletben léphetnek újra színpadra.

A pályázat leírása és a kapcsolódó anyagok az alábbi hivatkozásra kattintva tekinthetők meg:`,
      cta: {
        text: "Csoóri Sándor Program 2019",
        href: "https://emet.gov.hu/csoori-sandor-program-2019/"
      },
      images: [
        "/gallery/csoori19_01.jpeg",
        "/gallery/csoori19_02.jpeg",
        "/gallery/csoori19_03.jpeg",
        "/gallery/csoori19_04.jpeg",
        "/gallery/csoori19_05.jpg",
        "/gallery/csoori19_06.jpg",
        "/gallery/csoori19_07.jpg",
        "/gallery/csoori19_08.jpg",
        "/gallery/csoori19_09.jpg",
        "/gallery/csoori19_10.jpg",
        "/gallery/csoori19_11.jpg",
        "/gallery/csoori19_12.jpg",
        "/gallery/csoori19_13.jpg",
        "/gallery/csoori19_14.jpg",
        "/gallery/csoori19_15.jpg"
      ]
    }
  },
  {
    slug: "neao-kp-1-2024",
    title:
      "Múltunk a jelenünk, egyben a jövőnk. Működési célú támogatás, ruhatár bővítés - NEAO-KP-1-2024/2-001217",
    type: "text",
    parts: {
      body:
        "",
    },
  },
  {
    slug: "HUNG-2025-12836",
    title:
      "Hungarikum 2025 „Szülőföldünk Somogyország” HUNG-2025/12836",
    type: "text",
    parts: {
      body:
        "",
    },
  },
  {
    slug: "csoori-2025",
    title:
      "Csoóri Sándor Program 2025",
    type: "text",
    parts: {
      body:
        "",
    },
  },
  {
    slug: "VCA-KP-1-2025-3-001515",
    title:
      "Városi Civil Alap 2025  „Somogyi népviselet varratása” VCA-KP-1-2025/3-001515",
    type: "text",
    parts: {
      body:
        "",
    },
  }
];

// ------------------------------------------------------------
// LISTA – /grants
// ------------------------------------------------------------
export function GrantsList() {
  return (
    <main className="mx-auto max-w-5xl px-4 py-16">
      <h1 className="mb-12 text-center text-4xl font-bold">Elnyert pályázatok</h1>
      <div className="grid gap-10 md:grid-cols-2">
        {grants.map((g) => (
          <Link
            key={g.slug}
            to={`/grants/${g.slug}`}
            className="block rounded-xl border border-gray-200 p-6 shadow-sm hover:shadow-md"
          >
            <p className="text-center font-medium text-gray-700">{g.title}</p>
          </Link>
        ))}
      </div>
    </main>
  );
}

// ------------------------------------------------------------
// VIEWER – /grants/:slug
// ------------------------------------------------------------
export function GrantDetail() {
  const { slug } = useParams();
  const nav = useNavigate();
  const grant = grants.find((g) => g.slug === slug);

  if (!grant) return <p className="p-10 text-center">Pályázat nem található.</p>;

  const { title, type, parts } = grant;

  return (
    <main className="mx-auto max-w-6xl px-4 py-12">
      <button
        onClick={() => nav(-1)}
        className="mb-6 inline-flex items-center gap-2 text-sm text-primary hover:underline"
      >
        <ArrowLeftIcon className="h-4 w-4" /> Vissza
      </button>

      <h1 className="mb-8 text-center text-3xl font-bold">Elnyert pályázat</h1>
      <h2 className="mb-10 text-center text-2xl font-semibold text-primary max-w-4xl mx-auto">
        {title}
      </h2>

      {type === "text" && (
        <p className="mx-auto max-w-3xl text-center leading-relaxed text-gray-700 whitespace-pre-line">
          {parts.body}
        </p>
      )}

      {type === "pdf" && (
        <>
          {parts.files.map((f) => (
            <div key={f.file} className="mb-12">
              <h3 className="mb-2 text-lg font-medium">{f.label}</h3>
              <PdfViewer file={f.file} title={f.label} />
            </div>
          ))}
        </>
      )}

      {type === "gallery" && (
        <>
          {parts.heroImages && (
            <div className="mx-auto mb-10 grid max-w-3xl gap-6 sm:grid-cols-2">
              {parts.heroImages.map(src => (
                <img key={src} src={src} alt="" className="rounded-lg object-cover" />
              ))}
            </div>
          )}
          <p className="mx-auto mb-10 max-w-3xl text-center leading-relaxed text-gray-700 whitespace-pre-line">
            {parts.body}
          </p>

          {parts.cta && (
            <p className="mb-10 text-center text-lg">
              <a
                href={parts.cta.href}
                className="font-semibold text-primary underline hover:text-primary/80"
                target="_blank"
                rel="noreferrer"
              >
                {parts.cta.text}
              </a>
            </p>
          )}
          <Gallery images={parts.images} />
        </>
      )}
    </main>
  );
}

// PDF iframe
function PdfViewer({ file, title }) {
  const src = `/grants/${file}`;
  return (
    <div>
      <div className="mb-4 text-right">
        <a
          href={src}
          download
          className="inline-flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary/90"
        >
          <ArrowDownTrayIcon className="h-5 w-5" /> PDF letöltése
        </a>
      </div>
      <iframe
        src={src + "#toolbar=0"}
        title={title}
        className="h-[80vh] w-full rounded-md border"
      />
    </div>
  );
}

// Egyszerű kép‑rács (Tailwind grid)
function Gallery({ images }) {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {images.map((src) => (
        <img
          key={src}
          src={src}
          alt="Pályázati kép"
          className="rounded-lg object-cover shadow-sm"
        />
      ))}
    </div>
  );
}

// ------------------------------------------------------------
// Routes wrapper – /grants/*
// ------------------------------------------------------------
export default function GrantsRoutes() {
  return (
    <Routes>
      <Route index element={<GrantsList />} />
      <Route path=":slug" element={<GrantDetail />} />
    </Routes>
  );
}
